const WORKPLACE_CONSTRAINTS = {
  LABEL: {
    MIN_LENGTH: 3,
    MAX_LENGTH: 10
  }
};

export { WORKPLACE_CONSTRAINTS };
